import React, {Component } from 'react';
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { NotificationManager } from "../../components/common/react-notifications";
import ReactToPrint from 'react-to-print';
import _axios from "../../libs/axios";
import {objToQueryString, decimalFormat} from "../../helpers/Utils"
import moment from "moment";
import AppLocale from "../../config/lang";
import ReactExport from 'react-data-export';
import { cloneDeep } from "lodash"

class ExportTo extends Component {
  constructor(props) {
    super(props);
    let columns = cloneDeep(props.columns)
    columns.forEach((c, i) => { if(c.type === 'img') columns.splice(i, 1) })
    this.state = {
      data: [],
      disabled: false,
      multiDataSet: [],
      columns: columns
    };
  }

  componentDidMount() {
    if (this.props.ctxExportTo) this.props.ctxExportTo(this)
  }

  getData() {
    const success = (r) => {
      const getKeyAndValue = (obj) => {
        let newObj = {}
        this.state.columns.forEach(c => {
          for (const [key, value] of Object.entries(obj)) {
            if (key === c.accessor) {
              if (c.isDate) newObj[key] = (value ? moment(value).format(`${window.tenant.defaultDateFormat} ${window.tenant.defaultTimeFormat}`) : '')
              else if (c.isDecimal) newObj[key] = decimalFormat(value)
              else newObj[key] = value
            }
          }
        });
        return newObj
      }
      let items = []
      r.forEach(e => {
        if (Array.isArray(e)) e.forEach(ee => { items.push(getKeyAndValue(ee)) });
        else items.push(getKeyAndValue(e));
      });
      this.setState(({data: items}),() => {
        this.props.to === 'excel' ? this.generateExcel() : this.printTable()
        this.setState({data: []})
      })
    }

    if (this.props.local) {
      let localData = cloneDeep(this.props.ctxParent.state.data)
      success(localData)
      return
    }

    this.props.ctxParent.setState({progressBar: true})
    this.setState({ disabled: true})
    let fieldsToFilter = this.props.ctxParent.state.formFilter ? this.props.ctxParent.state.formFilter : {};

    // parent ID filter
    if(this.props.ctxParent.state.parentId) fieldsToFilter.parentId = this.props.ctxParent.state.parentId;

    // add filterBy
    if(this.props.ctxParent.props.filterBy) fieldsToFilter = {...fieldsToFilter, ...this.props.ctxParent.props.filterBy}

    let filters = objToQueryString(fieldsToFilter, false, true)
    let search = this.props.ctxParent.state.search ? ('&filter=' + this.props.ctxParent.state.search) : ''
    let path = this.props.ctxParent.state.resource + "/get/?print=true" + filters + search
    if (this.props.ctxParent.view.config.customPathGet) path = this.props.ctxParent.view.config.customPathGet + "/?print=true" + filters + search
    _axios
      .get(path)
      .then(r => {
        this.props.ctxParent.setState({progressBar: false})
        this.setState({ disabled: false})
        if (r.status >= 0) {
          if (r.data.Results.length > 0) {
            if (this.props.remap) r = this.props.ctxParent.view.config.remap(r)
            success(r.data.Results)
          } else NotificationManager.success("No hay datos", '', 5000, null, null, 'outline')
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      })
  }

  generateExcel () {
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    
    let multiDataSet = [
      {
        columns: [],
        data: []
      }
    ];
    
    // headers
    const {locale} = this.props
    const L = AppLocale[locale].messages
    this.state.columns.forEach(e => {
      multiDataSet[0].columns.push({title: L[e.Header]?? e.Header})
    });
    
    // rows
    this.state.data.forEach(e => {
      let row = []
      Object.keys(e).forEach(name => {
        row.push({value: e[name] ? e[name].toString() : ""})
      });
      multiDataSet[0].data.push(row)
    });

    let excelFile = new ExcelFile({
      hideElement: false,
      fileExtension: 'xlsx',
      filename: this.props.filename,
      children: <ExcelSheet dataSet={multiDataSet} name={this.props.filename}/>
    });
    excelFile.download()
  }

  printTable () {
    let tableToPrint = new ReactToPrint({
      content: () => this.componentRef,
      copyStyles: true,
      bodyClass: 'body-print'
    })
    tableToPrint.handleClick()
  }
  
  render() {
    const {locale, hideButton} = this.props
    const L = AppLocale[locale].messages
    return (
      <div className="container-exportTo">
        {!hideButton && <Button type="button" color="primary" size="sm" className="mr-2" onClick={() => {this.getData()}} disabled={this.state.disabled}>
          <i className={this.props.to === 'excel' ? 'simple-icon-grid' : 'simple-icon-printer'}></i> {this.props.to === 'excel' ? 'Excel' : L['main.print']}
          {this.state.disabled &&
            <span className="spinner d-inline-block">
              <span className="bounce1" />
              <span className="bounce2" />
              <span className="bounce3" />
            </span>
          }
        </Button>}

        <div style={{display: 'none'}}>
          {this.state.data.length > 0 && this.props.to !== 'excel' &&
            <table  id="table-to-export" ref={el => (this.componentRef = el)}>
              <thead>
                <tr>
                  <td colSpan="20">
                    <img alt="logo" width="60" className="rounded" src="https://jdblob.blob.core.windows.net/img/comp/santamaria.jpg" />
                    <b className="ml-2">Nombre reporte:</b> {this.props.filename}
                  </td>
                </tr>
                {/* <tr>
                  <td colSpan="20">
                      <b>Filtro 1:</b> Valor filtro 1, <b>Filtro 2:</b> Valor filtro 2,<b>Filtro 3:</b> Valor filtro 3
                  </td>
                </tr> */}
                <tr>
                  <td colSpan="20">
                      &nbsp;
                  </td>
                </tr>
                <tr>
                  {this.state.columns.map(c => {
                    return (
                      <th key={c.accessor}>{L[c.Header]?? c.Header}</th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {this.state.data.map((e, i) => {
                  return (
                    <tr key={i}>
                      {Object.keys(e).map((name, index) => {
                        return <td key={index}>{e[name]}</td>
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale };
};

export default connect(mapStateToProps)(ExportTo);